import React, { useReducer } from 'react'
import ScheduledPickupContext from './scheduledPickupContext'
import ScheduledPickupReducer from './scheduledPickupReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_SCHEDULED_PICKUP,
    GET_TODAY_COMPLETED,
    GET_TODAY_SERVING,
    GET_TODAY_WAITLIST,
    GET_SCHEDULED_PICKUP_DASHBOARD,
    GET_TODAY_BOOKING,
    GET_ALL_SCHEDULED_PICKUP_USER_DATA,
    GET_SCHEDULE_DATA,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './scheduledPickupTypes'

const ScheduledPickupState = (props) => {
    const initialState = {
        all_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        booking_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        serving_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        completed_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        waiting_scheduled_pickup: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_scheduled_pickup_user: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        scheduled_pickup_dashboard: {
            records: [],
        },
        schedule_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
    }

    const [state, dispatch] = useReducer(ScheduledPickupReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getScheduledPickupDashboardData = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getScheduledPickupDashboardData',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            from = from ? from : 'schedulepickupDasboard'

            if (res.data.status === 'success') {
                console.log(res.data.data.responseData, 'res.data')
                dispatch({
                    type: 'GET_SCHEDULED_PICKUP_DASHBOARD',
                    payload: {
                        records: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSchedulePickupTiming = async (formData, fromVariable) => {
        const from = fromVariable ? fromVariable : 'getSchedulePickupTiming'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getSchedulePickupTiming',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SCHEDULE_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const getAllScheduledPickup = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllScheduledPickup',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            from = from ? from : 'schedulepickup'

            if (res.data.status === 'success') {
                dispatch({
                    type:
                        from == 'one'
                            ? 'GET_TODAY_BOOKING'
                            : from == 'two'
                              ? 'GET_TODAY_WAITLIST'
                              : from == 'three'
                                ? 'GET_TODAY_SERVING'
                                : from == 'four'
                                  ? 'GET_TODAY_COMPLETED'
                                  : 'GET_ALL_SCHEDULED_PICKUP',
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllScheduledPickupUserData = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllScheduledPickupUserData',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            from = from ? from : 'schedulepickupUser'
            console.log('777777777777', res.data.data.responseData)
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_SCHEDULED_PICKUP_USER_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeProductStatus = async (formData, from) => {
        try {
            //const from = 'productchange'
            from = from ? from : 'productchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const schedulePickupAction = async (formData, variable) => {
        try {
            const from = variable ? variable : 'scheduledPickupAction'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'scheduledPickupAction',
                    formData,
                    '',
                    'schedulepickup'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ScheduledPickupContext.Provider
            value={{
                all_scheduled_pickup: state.all_scheduled_pickup,
                waiting_scheduled_pickup: state.waiting_scheduled_pickup,
                serving_scheduled_pickup: state.serving_scheduled_pickup,
                completed_scheduled_pickup: state.completed_scheduled_pickup,
                booking_scheduled_pickup: state.booking_scheduled_pickup,
                all_scheduled_pickup_user: state.all_scheduled_pickup_user,
                scheduled_pickup_dashboard: state.scheduled_pickup_dashboard,
                schedule_data: state.schedule_data,
                responseStatus: state.responseStatus,
                clearResponse,
                getAllScheduledPickup,
                getAllScheduledPickupUserData,
                getScheduledPickupDashboardData,
                getSchedulePickupTiming,
                schedulePickupAction,
                changeProductStatus,
            }}
        >
            {props.children}
        </ScheduledPickupContext.Provider>
    )
}

export default ScheduledPickupState
